<div class="p-5">
    <div class="d-flex justify-content-end" (click)="close()">
        <img class="c-pointer" width="12" height="12" src="assets/icons/close.svg" alt="">
    </div>
    <div class="text-center mt-3 text-36-600-122 text-c7 mb-4">{{'QR Code' | translate}}</div>
    <div class="qr-img-container">
        <ngx-qrcode 
            [elementType]="'url'" 
            [value]="qrLink"
            cssClass="qr-img-container"
            [margin]="0"
            errorCorrectionLevel="M">
        </ngx-qrcode>
        <!-- <img style="min-width: 100%;" src="assets/icons/qr-demo.svg" alt=""> -->
    </div>
</div>
